import { render, staticRenderFns } from "./newHelp.vue?vue&type=template&id=54ee5142&scoped=true"
import script from "./newHelp.vue?vue&type=script&lang=js"
export * from "./newHelp.vue?vue&type=script&lang=js"
import style0 from "./newHelp.vue?vue&type=style&index=0&id=54ee5142&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ee5142",
  null
  
)

export default component.exports